import styled from "styled-components";

export const Backdrop = styled.div`
    position: fixed; inset: 0; background: rgba(20,26,38,0.45);
    display: flex; align-items: center; justify-content: center; z-index: 1000;
`;
export const Card = styled.div`
    background: #FFFFFF; border-radius: 14px; width: 640px; max-width: 94vw;
    max-height: 92vh; overflow-y: auto; font-family: Mulish;
`;
export const Header = styled.div`
    display: flex; align-items: flex-start; justify-content: space-between;
    padding: 20px 26px 16px; border-bottom: 1px solid #EEF1F6;
`;
export const HeadText = styled.div`display: flex; flex-direction: column;`;
export const Title = styled.h3`margin: 0; font-size: 1.15rem; font-weight: 800; color: #2B3240;`;
export const Hint = styled.p`margin: 4px 0 0; font-size: 0.84rem; color: #8A94A6;`;
export const CloseBtn = styled.button`
    flex: 0 0 auto; width: 28px; height: 28px; border-radius: 50%; border: none;
    background: #EEF1F6; color: #6B7280; display: flex; align-items: center; justify-content: center;
    cursor: pointer; font-size: 1rem;
    &:hover { background: #E3E8F0; }
`;
export const Body = styled.div`padding: 18px 26px 4px;`;
export const Label = styled.label`display: block; font-size: 0.82rem; font-weight: 700; color: #2B3240; margin: 16px 0 7px;`;
export const Input = styled.input`
    width: 100%; box-sizing: border-box; border: 1px solid #E3E8F0; border-radius: 8px;
    padding: 12px 14px; font-family: Mulish; font-size: 0.9rem; background: #F7F9FC; color: #2B3240;
    &:focus { outline: none; border-color: #2F80ED; }
    &::placeholder { color: #B7BEC9; }
`;
export const Tabs = styled.div`display: flex; gap: 10px;`;
export const Tab = styled.button`
    flex: 1; border: 1px solid ${(p) => (p.$active ? "#2F80ED" : "#E3E8F0")};
    background: ${(p) => (p.$active ? "#EAF2FE" : "#FFFFFF")};
    color: ${(p) => (p.$active ? "#2F80ED" : "#6B7280")};
    font-family: Mulish; font-weight: 700; font-size: 0.86rem; padding: 10px 0; border-radius: 8px; cursor: pointer;
`;
export const RoleDesc = styled.p`margin: 8px 2px 0; font-size: 0.78rem; color: #8A94A6;`;
export const KeyBox = styled.div`
    display: flex; align-items: center; justify-content: space-between; gap: 8px;
    border: 1px solid #E3E8F0; border-radius: 8px; padding: 12px 14px; background: #F7F9FC;
    font-family: monospace; font-size: 1rem; letter-spacing: 2px; color: #2B3240; font-weight: 700;
`;
export const IconBtn = styled.button`
    flex: 0 0 auto; border: none; background: transparent; color: #2F80ED; cursor: pointer;
    display: flex; align-items: center; font-size: 1.1rem; padding: 0;
`;
export const SubHint = styled.p`margin: 6px 2px 0; font-size: 0.76rem; color: #9AA4B2;`;
export const AccessTitle = styled.p`
    margin: 20px 0 8px; font-size: 0.92rem; font-weight: 800; color: #2B3240;
    strong { color: #2F80ED; }
`;
export const Checklist = styled.ul`list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 8px;`;
export const CheckItem = styled.li`
    display: flex; align-items: center; gap: 9px; font-size: 0.84rem; font-weight: 600;
    color: ${(p) => (p.$on ? "#2B3240" : "#9AA4B2")};
`;
export const Warn = styled.div`
    margin-top: 14px; padding: 9px 13px; border-radius: 8px; background: #FFF7E6;
    border: 1px solid #FFE1A8; color: #8A6D3B; font-size: 0.78rem; line-height: 1.4;
`;
export const Success = styled.div`
    margin-top: 14px; padding: 9px 13px; border-radius: 8px; background: #E9F9EF;
    border: 1px solid #B7E9C9; color: #1F7A44; font-size: 0.8rem; font-weight: 700;
`;
export const Footer = styled.div`
    display: flex; align-items: center; justify-content: space-between; gap: 12px;
    padding: 16px 26px; margin-top: 18px; border-top: 1px solid #EEF1F6;
`;
export const FooterNote = styled.span`font-size: 0.78rem; color: #9AA4B2;`;
export const Actions = styled.div`display: flex; gap: 10px;`;
export const CancelBtn = styled.button`
    border: none; background: #384250; color: #FFF; font-family: Mulish; font-weight: 700;
    font-size: 0.84rem; padding: 10px 20px; border-radius: 8px; cursor: pointer;
`;
export const SendBtn = styled.button`
    border: none; background: #2F80ED; color: #FFF; font-family: Mulish; font-weight: 700;
    font-size: 0.84rem; padding: 10px 24px; border-radius: 8px; cursor: pointer;
    &:disabled { opacity: 0.5; cursor: not-allowed; }
`;
